export const translations = {
  ro: {
    // General
    app_name: "EcoWash Dashboard",
    loading: "Se incarca...",
    save: "Salveaza",
    cancel: "Anuleaza",
    delete: "Sterge",
    edit: "Editeaza",
    add: "Adauga",
    search: "Cauta",
    filter: "Filtreaza",
    actions: "Actiuni",
    status: "Status",
    active: "Activ",
    inactive: "Inactiv",
    expired: "Expirat",
    all: "Toate",
    confirm_delete: "Esti sigur ca vrei sa stergi acest element?",
    yes: "Da",
    no: "Nu",
    
    // Auth
    login: "Autentificare",
    register: "Inregistrare",
    email: "Email",
    password: "Parola",
    first_name: "Prenume",
    last_name: "Nume",
    phone: "Telefon",
    company_name: "Nume companie",
    cnp_cui: "CNP/CUI",
    login_title: "Bine ai revenit",
    login_subtitle: "Administreaza spalatoria ta auto",
    register_title: "Creeaza cont",
    logout: "Deconectare",
    invalid_credentials: "Email sau parola invalida",
    
    // Navigation
    dashboard: "Panou de control",
    locations: "Locatii",
    subscription_types: "Tipuri abonamente",
    subscriptions: "Abonamente",
    users: "Utilizatori",
    cars: "Masini",
    documents: "Documente",
    settings: "Setari",
    email_settings: "Setări Email",
    feedback: "Feedback",
    app_settings: "Setări Aplicație",
    car_catalog: "Catalog Mașini",
    sms: "Trimitere SMS",
    send_email: "Trimite Email",
    app_notifications: "Notificări Aplicație",
    facturare: "Facturare",
    diagnostics: "Diagnoză",

    // Dashboard
    total_subscriptions: "Total abonamente",
    active_subscriptions: "Abonamente active",
    expired_subscriptions: "Abonamente expirate",
    total_locations: "Total locatii",
    total_users: "Total utilizatori",
    add_user: "Adauga user",
    user_created: "Utilizator creat cu succes",
    total_cars: "Total masini",
    revenue_potential: "Venit potential",
    subscriptions_by_type: "Abonamente per tip",
    recent_subscriptions: "Abonamente recente",
    
    // Locations
    add_location: "Adauga locatie",
    edit_location: "Editeaza locatie",
    location_name: "Nume locatie",
    address: "Adresa",
    city: "Oras",
    no_locations: "Nu exista locatii",
    location_created: "Locatie creata cu succes",
    location_updated: "Locatie actualizata cu succes",
    location_deleted: "Locatie stearsa cu succes",
    
    // Subscription Types
    add_subscription_type: "Adauga tip abonament",
    edit_subscription_type: "Editeaza tip abonament",
    subscription_type_name: "Nume",
    description: "Descriere",
    price: "Pret",
    duration_days: "Durata (zile)",
    wash_count: "Numar spalari",
    unlimited: "Nelimitat",
    category: "Categorie",
    valid_for_category: "Valabil pentru categoria",
    no_subscription_types: "Nu exista tipuri de abonamente",
    subscription_type_created: "Tip abonament creat cu succes",
    subscription_type_updated: "Tip abonament actualizat cu succes",
    subscription_type_deleted: "Tip abonament sters cu succes",
    
    // User Subscriptions
    add_subscription: "Adauga abonament",
    edit_subscription: "Editeaza abonament",
    select_user: "Selecteaza utilizator",
    select_car: "Selecteaza masina",
    select_subscription_type: "Selecteaza tip abonament",
    start_date: "Data inceput",
    end_date: "Data sfarsit",
    washes_remaining: "Spalari ramase",
    license_plate: "Numar inmatriculare",
    user_name: "Nume utilizator",
    no_subscriptions: "Nu exista abonamente",
    subscription_created: "Abonament creat cu succes",
    subscription_updated: "Abonament actualizat cu succes",
    subscription_deleted: "Abonament sters cu succes",
    
    // Users
    toggle_admin: "Schimba rol admin",
    toggle_active: "Schimba status activ",
    toggle_shared_qr_month_on: "QR distribuit valabil până la sfârșitul lunii (activ) — apasă pentru a reveni la regula globală",
    toggle_shared_qr_month_off: "Fă QR-ul distribuit valabil până la sfârșitul lunii",
    is_admin: "Administrator",
    is_active: "Activ",
    user_updated: "Utilizator actualizat cu succes",
    no_users: "Nu exista utilizatori",
    user_details: "Detalii utilizator",
    created_at: "Data înregistrării",
    email_verified: "Email verificat",
    referral_code: "Cod propriu de recomandare",
    referred_by: "Recomandat de",
    no_referral_code: "Nu a folosit un cod de recomandare",
    referral_pending: "încă neconfirmat",
    referral_counted: "contorizat",
    referrer_deleted: "a folosit un cod, dar contul care l-a recomandat nu mai există",
    error: "Eroare",
    viewer: "Operator",
    referrals_count: "Nr. recomandări",
    referral_rewards: "Recompense recomandări",
    no_referral_rewards: "Nicio recompensă",
    edit_address: "Editează adresa",
    county: "Județ",

    // Invoicing (FGO)
    fgo_settings: "Configurare FGO",
    fgo_api_key: "Cheie API FGO (PrivateKey)",
    fgo_api_key_hint: "Din contul FGO: Setări → Users → cheia API a unui utilizator API (nu parola contului tău FGO)",
    fgo_cif: "CIF Companie",
    fgo_series: "Serie Factură",
    save_fgo_settings: "Salvează configurarea",
    invoices_missing: "plăți confirmate nu au factură",
    send_missing_invoices: "Generează și trimite facturile lipsă",
    invoice_backfill_result: "Procesate: {processed}, trimise: {sent}, eșuate: {failed}",
    no_invoices: "Nu există facturi",
    invoice_retried: "Factura a fost retrimisă",
    retry: "Reîncearcă",

    // Cars
    add_car: "Adauga masina",
    brand: "Marca",
    model: "Model",
    color: "Culoare",
    no_cars: "Nu exista masini",
    car_created: "Masina creata cu succes",
    car_deleted: "Masina stearsa cu succes",
    
    // Filters
    filter_by_status: "Filtreaza dupa status",
    filter_by_type: "Filtreaza dupa tip",
    clear_filters: "Sterge filtre",
    
    // Theme
    light_mode: "Mod luminos",
    dark_mode: "Mod intunecat",
    
    // Language
    language: "Limba",
    romanian: "Romana",
    english: "Engleza",

    // Days
    days: "zile",
    washes: "spalari",
    ron: "RON",
  },
  en: {
    // General
    app_name: "EcoWash Dashboard",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    filter: "Filter",
    actions: "Actions",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    expired: "Expired",
    all: "All",
    confirm_delete: "Are you sure you want to delete this item?",
    yes: "Yes",
    no: "No",
    
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    first_name: "First name",
    last_name: "Last name",
    phone: "Phone",
    company_name: "Company name",
    cnp_cui: "CNP/CUI",
    login_title: "Welcome back",
    login_subtitle: "Manage your car wash business",
    register_title: "Create account",
    logout: "Logout",
    invalid_credentials: "Invalid email or password",
    
    // Navigation
    dashboard: "Dashboard",
    locations: "Locations",
    subscription_types: "Subscription Types",
    subscriptions: "Subscriptions",
    users: "Users",
    cars: "Cars",
    documents: "Documents",
    settings: "Settings",
    email_settings: "Email Settings",
    feedback: "Feedback",
    app_settings: "App Settings",
    car_catalog: "Car Catalog",
    sms: "Send SMS",
    send_email: "Send Email",
    app_notifications: "App Notifications",
    facturare: "Invoicing",
    diagnostics: "Diagnostics",

    // Dashboard
    total_subscriptions: "Total subscriptions",
    active_subscriptions: "Active subscriptions",
    expired_subscriptions: "Expired subscriptions",
    total_locations: "Total locations",
    total_users: "Total users",
    add_user: "Add user",
    user_created: "User created successfully",
    total_cars: "Total cars",
    revenue_potential: "Revenue potential",
    subscriptions_by_type: "Subscriptions by type",
    recent_subscriptions: "Recent subscriptions",
    
    // Locations
    add_location: "Add location",
    edit_location: "Edit location",
    location_name: "Location name",
    address: "Address",
    city: "City",
    no_locations: "No locations found",
    location_created: "Location created successfully",
    location_updated: "Location updated successfully",
    location_deleted: "Location deleted successfully",
    
    // Subscription Types
    add_subscription_type: "Add subscription type",
    edit_subscription_type: "Edit subscription type",
    subscription_type_name: "Name",
    description: "Description",
    price: "Price",
    duration_days: "Duration (days)",
    wash_count: "Wash count",
    unlimited: "Unlimited",
    category: "Category",
    valid_for_category: "Valid for category",
    no_subscription_types: "No subscription types found",
    subscription_type_created: "Subscription type created successfully",
    subscription_type_updated: "Subscription type updated successfully",
    subscription_type_deleted: "Subscription type deleted successfully",
    
    // User Subscriptions
    add_subscription: "Add subscription",
    edit_subscription: "Edit subscription",
    select_user: "Select user",
    select_car: "Select car",
    select_subscription_type: "Select subscription type",
    start_date: "Start date",
    end_date: "End date",
    washes_remaining: "Washes remaining",
    license_plate: "License plate",
    user_name: "User name",
    no_subscriptions: "No subscriptions found",
    subscription_created: "Subscription created successfully",
    subscription_updated: "Subscription updated successfully",
    subscription_deleted: "Subscription deleted successfully",
    
    // Users
    toggle_admin: "Toggle admin role",
    toggle_active: "Toggle active status",
    toggle_shared_qr_month_on: "Shared QR valid until month end (on) — click to revert to the global rule",
    toggle_shared_qr_month_off: "Make the shared QR valid until the end of the month",
    is_admin: "Administrator",
    is_active: "Active",
    user_updated: "User updated successfully",
    no_users: "No users found",
    user_details: "User details",
    created_at: "Registered on",
    email_verified: "Email verified",
    referral_code: "Own referral code",
    referred_by: "Referred by",
    no_referral_code: "Did not use a referral code",
    referral_pending: "not confirmed yet",
    referral_counted: "counted",
    referrer_deleted: "used a code, but the referring account no longer exists",
    error: "Error",
    viewer: "Operator",
    referrals_count: "Referrals",
    referral_rewards: "Referral rewards",
    no_referral_rewards: "No rewards",
    edit_address: "Edit address",
    county: "County",

    // Invoicing (FGO)
    fgo_settings: "FGO Configuration",
    fgo_api_key: "FGO API Key (PrivateKey)",
    fgo_api_key_hint: "From your FGO account: Settings → Users → an API user's key (not your own FGO account password)",
    fgo_cif: "Company CIF",
    fgo_series: "Invoice Series",
    save_fgo_settings: "Save configuration",
    invoices_missing: "confirmed payments have no invoice",
    send_missing_invoices: "Generate and send missing invoices",
    invoice_backfill_result: "Processed: {processed}, sent: {sent}, failed: {failed}",
    no_invoices: "No invoices found",
    invoice_retried: "Invoice resent",
    retry: "Retry",

    // Cars
    add_car: "Add car",
    brand: "Brand",
    model: "Model",
    color: "Color",
    no_cars: "No cars found",
    car_created: "Car created successfully",
    car_deleted: "Car deleted successfully",
    
    // Filters
    filter_by_status: "Filter by status",
    filter_by_type: "Filter by type",
    clear_filters: "Clear filters",
    
    // Theme
    light_mode: "Light mode",
    dark_mode: "Dark mode",
    
    // Language
    language: "Language",
    romanian: "Romanian",
    english: "English",

    // Days
    days: "days",
    washes: "washes",
    ron: "RON",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};
